export default "__VITE_ASSET__BAgNG3cP__"